import { GzSchedulerWebComponent } from './component/GzSchedulerWebComponent';

export { GzSchedulerWebComponent };
